import { render } from "./Itemedit4posterjack.vue?vue&type=template&id=2eabfe33&scoped=true&ts=true"
import script from "./Itemedit4posterjack.vue?vue&type=script&lang=ts"
export * from "./Itemedit4posterjack.vue?vue&type=script&lang=ts"

import "./Itemedit4posterjack.vue?vue&type=style&index=0&id=2eabfe33&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eabfe33"]])

export default __exports__